/** Command palette + search (`features/search/CommandPalette.tsx`). */
export const search = {
  'search.palette.placeholder': 'Search pages…  (> commands, # tags, @ pages)',
  'search.palette.placeholderCommands': 'Run a command…',
  'search.palette.placeholderTags': 'Jump to a tag…',
  'search.palette.empty': 'No results.',
  'search.palette.openSettings': 'Open settings',
  'search.palette.label': 'Command palette',
  'search.palette.noTagsYet': 'No tags yet. Add one from a page’s header.',
  'search.palette.noTagsMatch': 'No tags match “{query}”.',
  'search.palette.noPagesMatch': 'No pages match “{query}”.',
  'search.palette.noCommandsMatch': 'No commands match “{query}”.',
  'search.palette.tags': 'Tags',
  'search.palette.favorites': 'Favorites',
  'search.palette.recent': 'Recent',
  'search.palette.pages': 'Pages',
  'search.palette.events': 'Events',
  'search.palette.createPagePrefix': 'Create page “',
  'search.palette.createPageSuffix': '”',
  'search.palette.pageCount.one': '{count} page',
  'search.palette.pageCount.other': '{count} pages',

  'search.commands.heading': 'Commands',
  'search.commands.newPage': 'New page',
  'search.commands.newEvent': 'New event',
  'search.commands.setDueDate': 'Set due date',
  'search.commands.goToAgenda': 'Go to Agenda',
  'search.commands.goToCalendar': 'Go to Calendar',
  'search.commands.goToChat': 'Go to AI Chat',
  'search.commands.newChildPage': 'New child page',
  'search.commands.removeFromFavorites': 'Remove from favorites',
  'search.commands.addToFavorites': 'Add to favorites',
  'search.commands.toggleTheme': 'Toggle theme (now: {theme})',
  'search.commands.toggleDensity': 'Toggle density',
  'search.commands.openTrash': 'Open trash',
  'search.commands.emptyTrash': 'Empty trash',
  'search.commands.shortcuts': 'Keyboard shortcuts',
} as const;
